<template>
  <div class="voice-editor" v-if="visible">
    <div class="reader" v-if="readerObj">
      <div class="figure-wrapper">
        <div class="figure">
          <img :src="$handleAssetsUrl(readerObj.iconUrl)" alt="" />
        </div>
        <div :class="badgeClassName" v-if="readerObj.aiType"></div>
      </div>
      <div class="name">{{ readerObj.label }}</div>
    </div>
    <div class="content" @click.stop>
      <div class="text">
        <textarea
          class="textarea"
          contenteditable
          :placeholder="textarea.placeholder"
          @keydown.stop="limitTextarea($event)"
          @keyup.stop
          @click="limitTextarea($event)"
          @select="onSelectText"
          @paste="onPaste"
          @input="onChange"
          v-model="textarea.value"
          ref="textareaRef"
        >
        <!-- {{ textarea.value }} -->
        </textarea>
      </div>
      <div class="control">
        <div class="row">
          <div class="row-item">
            <div class="row-item__name">插入停顿(s)</div>
            <div class="row-item__content df">
              <div
                class="btn-small margin"
                v-for="(item, i) in insertSpace"
                :key="i"
                @click="
                  insertSpaceRecord({
                    sec: item.value,
                  })
                "
              >
                {{ item.value }}
              </div>
            </div>
          </div>
          <!-- 下拉菜单 -->
          <div class="menu-container row-item is-grow">
            <!-- <div class="name">特殊发音：</div> -->
            <Menu
              :title="'多音字'"
              :options="polyphoneList"
              @triggerOn="onPolyphoneMenuToggle"
              @clickItem="setCharPolyphone"
            >
              <template v-slot:icon>
                <iconfont
                  name="#iconduoyinzi"
                  font-size="16px"
                  style="margin-right: 2px"
                ></iconfont>
              </template>
            </Menu>
            <div style="width: 24px"></div>
            <Menu
              :disabled="readerObj && readerObj.provider === 3"
              :title="'数字读法'"
              :options="numberList"
              @triggerOn="onNumberMenuToggle"
              @clickItem="setNumberSpeaking"
            >
              <template v-slot:icon>
                <iconfont
                  name="#iconshuzidufa"
                  font-size="20px"
                  style="margin-right: 6px; margin-top: 2.5px"
                ></iconfont>
              </template>
            </Menu>
          </div>
        </div>

        <div
          v-if="readerObj"
          class="speed-range"
          :text="speeds[readerObj.provider]"
          :text1="readerObj.provider"
        >
          <div class="name">语速:</div>
          <div class="content">
            <div class="range-wrapper">
              <SpeedRange
                v-if="maxSpeed < Infinity"
                v-model="speeds[(readerObj || {}).provider]"
                :min="minSpeed"
                :max="maxSpeed"
                :step="rangeStep"
                ref="speedRange"
              ></SpeedRange>
            </div>
          </div>
        </div>
      </div>
      <div class="submit">
        <div
          class="test-play"
          style="width: 279px;"
        >
          <!-- <iconfont
            :name="testPlayState === 'play' ? '#bofang2' : '#bofang'"
            font-size="18px"
            style="color: #5778FB"
          ></iconfont> -->
          <svg
            viewBox="0 0 1024 1024" width="18" height="18" @click="testPlay()"
            :class="{ 'is-disabled': false }"
            ref="testPlayBtn"
          >
            <use :href="testPlayState === 'play' ? '#icon-test-pause' : '#icon-test-play'"></use>
          </svg>
          <span class="text" v-if="!testingVoiceMsg">试听</span>
          <div class="text testing-remain" v-if="testingVoiceMsg">
            <span>试听</span>
            <!-- {{testingVoiceMsg}}
            <div class="testing-remain-tip">
              普通用户每天最多可生成{{testingVoiceInfo.total}}次配音试听
            </div> -->
            <div class="icon-free"></div>
          </div>
          <div class="dur" :style="{ opacity: audioDur ? 1 : 0, 'pointer-event': 'none' }">
            (时长:{{ audioDur }}s)
          </div>
        </div>
        <div class="cancel" v-if="isShowCancel" @click="cancel">取消</div>
        <div class="cancel" v-else style="visibility: hidden">取消</div>
        <div
          class="confirm"
          :class="{ 'is-disabled': !allowedTest }"
          @click="send()"
        >
          确定
        </div>
      </div>
    </div>
    <RecordPlayer
      ref="recordPlayer"
      @playStart="playStart"
      @playStop="playStop"
      @loadedMeta="onLoadedMeta"
    ></RecordPlayer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Menu from './menu';
import RecordPlayer from '@/components/emodal/generateVoice/recordPlayer';
import SpeedRange from './range.vue';

export default {
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    readerOpts: {
      type: Array,
      default () {
        return [];
      }
    },
    reader: {
      type: String
    },
    readerId: {},
    startText: {},
    voiceData: {},
    isShowCancel: {
      default: true
    }
  },
  components: {
    Menu,
    RecordPlayer,
    SpeedRange,
    iconfont: () => import('@/platformCode/iconfont')
  },
  data () {
    return {
      dialogToTop: "60px",
      // readerOpts: [
      //   {
      //     label: "",
      //     value: ""
      //   }
      // ],
      // reader: "",
      readerObj: null,
      speed: 100,
      speeds: {
        0: 5,
        2: 4.5,
        3: 5,
        4: 5,
        5: 5,
        6: 5.5
      },
      minSpeed: 0,
      maxSpeed: Infinity,
      insertSpace: [
        {
          value: 0.5
        },
        {
          value: 1
        },
        {
          value: 2
        }
      ],
      durations: {
        scene: 0,
        record: 0
      },
      textarea: {
        // placeholder: '来画君今天来上学，很高兴见到大家',
        placeholder: "请在此处输入文字...",
        // value: '的空[0.5秒]间[1秒]法式[2秒]咖啡',
        value: "",
        maxlength: 350,
        cacheValue: ""
      },
      playBtnState: "play",
      playBtnShape: "icon-music-play",
      remainChars: {
        play: 0,
        generate: 0
      },
      step: {
        name: "generate" // generate | name
      },
      isGenerating: false,
      isGeneratingSuccess: false,
      fullscreenLoading: null,
      listenedParams: null,
      geneUrl: "",
      geneFileName: "",
      isRecordNameValid: true,
      progressTip: {
        percent: 0,
        isShow: false,
        tid: null
      },
      isLock: false,
      placeTexts: {
        global: "全局",
        scene: "单页"
      },
      polyphoneList: [],
      numberList: [
        { label: '数值读法', value: 2 },
        { label: '电报读法', value: 1 }
      ],
      sliderTipVisible: false,
      audioDur: 0,
      testingVoiceMsg: '',
      testingVoiceInfo: {},
      testPlayState: ''
    };
  },
  computed: {
    readerData () {
      return this.readerOpts.find(v => v.sourceId == this.reader);
    },
    rangeStep () {
      return (this.maxSpeed - this.minSpeed) / 8;
    },
    dialogProps () {
      let { visible } = this;

      return {
        visible,
        width: "890px",
        "modal-append-to-body": false,
        "show-close": false,
        top: this.dialogToTop,
        "close-on-click-modal": false
      };
    },
    testPlayStatex () {
      const s = this.$refs && this.$refs.recordPlayer && this.refs.recordPlayer.playState
      return s || '';
    },
    ...mapGetters([
      "Window_Size",
      "TOOL",
      "PreviewType",
      "SoundRecord",
      "UserLevel",
      "UserLevelType",
      "UserMsg",
      "IsDoingSmartVoice",
      "AIReader",
      "isPersonVip",
      'UserLevelInfo',
      'IsOldUser',
      'IsProLevelSystem'
    ]),
    allowedTest () {
      // if (this.UserLevelInfo.levelName === 'basic' && this.testingVoiceInfo.remain === 0) {
      //   return false;
      // }
      return this.textarea && this.getTextLength(this.textarea.value);
    },
    userLevelAllowedTest () {
      const matched = this.UserLevelInfo.levelName === 'basic' || this.UserLevelInfo.levelName === 'person' && this.UserLevelInfo.trial;
      if (matched && this.testingVoiceInfo.remain === 0) {
        return false;
      }
      return true;
    },
    badgeClassName () {
      const isProLevelSystem = this.IsProLevelSystem
      let name = isProLevelSystem ? 'badge pro' : 'badge';
      if (this.readerObj.aiType === 2) {
        if (this.IsOldUser) {
          name = 'badge person';
        } else {
          name = isProLevelSystem ? 'badge proPlus' : 'badge enterpriseS';
        }
      }
      return name;
    }
  },
  watch: {
    "textarea.value": function (val, old) {
      let textLen = this.getTextLength(val);
      let maxLen = this.textarea.maxlength;
      if (textLen > maxLen) {
        let valLen = this.textarea.value.length || 0;
        this.textarea.value = val.slice(0, maxLen + valLen - textLen);
        this.$message({
          message: `每次转换不能超过${maxLen}字`,
          type: "error"
        });
      }

      if (this.settingNumberSpeaking) {
        this.settingNumberSpeaking = false;
        return;
      }

      if (old.length > val.length) {
        return;
      }

      let startPos = this.$refs.textareaRef.selectionStart;
      let part = val.slice(0, startPos);
      let part0 = part.replace(/\[[0-9\.\[\]]*\u79d2\]/g, '');
      let pos = startPos - (part.length - part0.length);

      let { points } = this.decodeText();
      let sum = 0;
      let max = 20;
      // let reader = (this.readerOpts.filter(v => v.value === this.reader) || [])[0];
      // if (reader.provider === 2) {
      //   max = 3;
      // }
      let cursor = this.$refs.textareaRef.selectionStart;
      // let k = window.clientInformation.clipboard.read()
      points.some((v, i) => {
        let prev = points[i - 1] || points[0];
        if (v.index !== prev.index) {
          sum = 0;
        }

        sum += v.duration;
        if (sum > max * 1000 && pos === v.index && val[startPos - 1] === ']' && val[startPos - 2] === '秒') {
          this.textarea.value = old; // this.shorten();
          let diffNum = val.length - old.length;
          let newPos = startPos - diffNum;
          let textareaRef = this.$refs.textareaRef;
          this.$nextTick(() => {
            textareaRef.focus();
            // textareaRef.setSelectionRange(newPos, newPos);
            this.setSelectionRange(textareaRef, newPos, newPos);
          });
          // if (reader.provider === 2) {
          //   let names = this.getReaderNames().join('、') || '';
          //   this.showProviderPauseMsg({ max, names });
          // } else {
          //   this.$message.error({
          //     message: `累计添加的停顿不可超过${max}秒`
          //   });
          // }
          this.$message.error({
            message: `累计添加的停顿不可超过${max}秒`
          });
          return true;
        }
      });
    },
    isGenerating (val) {
      if (val) {
        this.fullscreenLoading = this.$loading({
          lock: true,
          spinner: "el-laihua-loading",
          text: "",
          customClass: "gene_recoring"
        });

        // let mask = document.body.querySelector(".gene_recoring");
        // $('body > .progress.__smart-voice')
        // this.$refs.progressRef.style.zIndex = mask.style.zIndex - 0 + 10;
        // document.body.appendChild(this.$refs.progressRef);
        this.progressTip.isShow = true;
      } else {
        this.progressTip.isShow = false;
        this.fullscreenLoading && this.fullscreenLoading.close();
      }
    },
    reader (val) {
      this.handleReader(val, this.readerId);
    },
    readerId () {
      this.handleReader(this.reader, this.readerId);
    },
    "SoundRecord.isShowGenerateVoice": {
      handler (val) {
        if (val) {
          this.$store.commit("set_IsDoingSmartVoice", {
            flag: true
          });
        }
      }
    },
    'progressTip.isShow' (val) {
      this.$bus.emit('smartVoice.generating', val);
    }
  },
  created () {
    // this.listenedParams =
    // this.getReaders();
    this.$bus.on("nameContent.validate", flag => {
      this.isRecordNameValid = flag;
    });
    $('body').on('mouseup', this.onBodyMouseUp);
    if (this.startText) {
      this.textarea.value = this.startText;
    }

    this.initVoiceData();
    this.fetchTestVoiceCount();
  },
  mounted () {
    this.handleReader(this.reader, this.readerId);
  },
  beforeDestroy () {
    $('body > .progress.__smart-voice').remove();
    this.progressTip.isShow = false;
    this.fullscreenLoading && this.fullscreenLoading.close();
  },
  methods: {
    initVoiceData () {
      if (this.voiceData) {
        this.speeds[(this.readerObj || this.readerData).provider] = +this.voiceData.queryParams.speed;
        this.listenedParams = this.voiceData.queryParams;
      }
    },
    handleReader (val, readerId) {
      if (!val) {
        return;
      }
      let readerObj = (this.readerOpts.filter(r => {
        return readerId ? r.id === readerId : r.value === val;
      }) || [])[0];
      this.reader = readerObj.value;
      this.$store.commit("set_Reader", this.reader);
      this.readerObj = readerObj;
      this.minSpeed = +readerObj.minSpeed;
      this.maxSpeed = +readerObj.maxSpeed;
      this.textarea.maxlength = 350 || readerObj.maxSize;
      this.$refs.speedRange && this.$refs.speedRange.initPos();
    },
    toAnalysisParams (...args) {
      return toAnalysisParams(...args);
    },
    close (isEnd = false) {
      // this.$refs.recordPlayer.stop();
      if (this.step.name === "generate") {
        this.$emit("closeDialog");
      }
      if (this.step.name === "name") {
        // todo: save record
        this.createUserRecord();
        // this.step.name = 'generate';
      }
      if (isEnd) {
        this.$store.commit("set_IsDoingSmartVoice", {
          flag: false
        });
      }
    },
    initView () {
      this.setDialogTop();
      this.TOOL && this.getDurations();
      this.getRemainChars();
      // this.reader = this.readerOpts[0];
      this.$nextTick(() => {
        this.$refs.textareaRef && this.$refs.textareaRef.focus();
      });

      // 弹出气泡提示
      this.$bus.emit("showTips", {
        text: "在这里输入文字即可快速合成语音。",
        position: {
          top: `${window.innerHeight / 2 - 65}px`,
          left: `${window.innerWidth / 2 - 679}px`
        }
      });
    },
    onOpenDialog () {
      this.getReaders();
      this.initView();
    },
    setDialogTop () {
      this.$nextTick(() => {
        let parts =
          this.Window_Size.height -
          this.$refs.dialogRef.$refs.dialog.offsetHeight;
        let top = parts > 0 ? parts / 2 : 60;
        this.dialogToTop = top + "px";
      });
    },
    getReaders () {
      // this.$http.get('/api/user/kdxfaudio/source')
      this.$http
        .get("/api/user/audioAI/source")
        .then(res => {
          let { data } = res.data;
          this.readerOpts = data.map(read => {
            return {
              ...read,
              value: read.sourceId,
              label: read.sourceName
            };
          });
          if (this.AIReader) {
            this.reader = this.AIReader;
            this.$store.commit("set_Reader", "");
          } else {
            this.reader = this.readerOpts[0].value;
          }
        })
        .catch(this.err);
    },
    getRemainChars () {
      this.$http
        .get("/api/session/new")
        .then(res => {
          let { data, code, msg } = res.data;
          if (code !== 200) {
            throw new Error(msg);
          }
          let {
            kdxfRemain, // 剩余合成语音字数
            kdxfTimes // 剩余试听字数
          } = data;
          this.remainChars = {
            play: kdxfTimes,
            generate: kdxfRemain
          };
        })
        .catch(this.err);
    },
    onSelectChange () { },
    getDurations ({ record = 0 } = {}) {
      this.durations = {
        ...this.durations,
        ...{
          scene:
            this.PreviewType === "global"
              ? this.TOOL.getDuration() / 1000
              : this.TOOL.selectedScenes.getDuration() / 1000,
          record
        }
      };
    },
    getTextLength (text) {
      let pinyinRG = /\[\=[a-z]{1,6}[1-9]?\]/g;
      let numRG = /\[n[0-2]\]/g;
      // 秒 -- \u79d2
      //      let filtered = text.replace(/\[.*?秒\]/g, '');
      let filtered = this.decodeText().text;
      filtered = filtered.replace(pinyinRG, '').replace(numRG, '');
      return filtered.length;
    },
    getInsertSpaceSumTime (text) {
      text = text || this.textarea.value;
      let re = /\[([0-9\.]+)\u79d2\]/g;
      let arr = [];
      let sum = 0;
      text.replace(re, (m, c) => {
        sum = sum + (c - 0 || 0);
        arr.push(c - 0 || 0);
        return c + ",";
      });
      return {
        sum,
        arr
      };
    },
    insertSpaceRecord ({ sec = 0.5 } = {}) {
      let tpl = `[${sec.toFixed(1)}秒]`;
      let { textareaRef } = this.$refs;
      let { selectionStart, selectionEnd, value } = this.getSelection(textareaRef);
      let startPos = selectionStart;
      let endPos = selectionEnd;
      // let re = new RegExp(`^([\\s\\S]{${startPos})([\\s\\S]*)}`)
      // this.textarea.value.replace(re, '$1' + tpl + '$2')
      let parts = [];
      parts.push(this.textarea.value.slice(0, startPos));
      parts.push(tpl);
      parts.push(this.textarea.value.slice(endPos));

      let part0 = parts[0].replace(/\[[0-9\.\[\]]*\u79d2\]/g, '');
      let diffLen = parts[0].length - part0.length;
      let pos = startPos - diffLen;

      // let reader = (this.readerOpts.filter(v => v.value === this.reader) || [])[0];
      let max = 20;
      // if (reader.provider == 2) {
      //   max = 3;
      // }

      // if (this.getInsertSpaceSumTime(parts.join("")).sum > max) {
      //   this.$message.error({
      //     message: `累计添加的停顿不可超过${max}s`
      //   });
      //   return;
      // }
      let isBreakFn = false;
      let { points } = this.decodeText(parts.join(''));
      let sum = 0;
      points.some((v, i) => {
        let prev = points[i - 1] || points[0];
        if (v.index !== prev.index) {
          sum = 0;
        }

        sum += v.duration;
        if (sum > max * 1000 && pos === v.index) {
          isBreakFn = true;
          // if (reader.provider === 2) {
          //   let names = this.getReaderNames().join('、') || '';
          //   this.showProviderPauseMsg({ max, names });
          // } else {
          //   this.$message.error({
          //     message: `累计添加的停顿不可超过${max}s`
          //   });
          // }
          this.$message.error({
            message: `累计添加的停顿不可超过${max}s`
          });
          return true;
        }
      });

      if (isBreakFn) {
        return;
      }
      this.textarea.value = parts.join("");
      let newEndPos = parts[0].length + parts[1].length;
      this.$nextTick(() => {
        textareaRef.focus();
        // textareaRef.setSelectionRange(newEndPos, newEndPos);
        this.setSelectionRange(textareaRef, newEndPos, newEndPos);
      });
    },
    limitTextarea (ev) {
      const BACKSPACE = 8;
      const BL = 219; // 左中括号
      const BR = 221; // 右中括号
      const IME_KEY = 229;
      // ev.currentTarget.textContent = ev.currentTarget.textContent.replace(/<[\/\s]*(?:(?!div|br)[^>]*)>/g, '')
      // if (ev.currentTarget.textContent.length >= this.textarea.maxlength && ev.keyCode !== BACKSPACE) {
      //   ev.currentTarget.textContent = ev.currentTarget.textContent.slice(0, this.textarea.maxlength);
      //   ev.preventDefault();
      //   return;
      // }
      if (ev.keyCode >= 37 && ev.keyCode <= 40) {
        return;
      }
      if (ev.keyCode === BL || ev.keyCode === BR || ev.keyCode === 229) {
        ev.preventDefault();
      }
      let { textareaRef } = this.$refs;
      let { selectionStart, selectionEnd, value } = this.getSelection(textareaRef);
      let startPos = selectionStart;
      let endPos = selectionEnd;
      let list = this.textarea.value.slice(0, startPos).match(/(\[)[^\]]*$/);
      let list2 = this.textarea.value.slice(endPos).match(/^[^\[]*(\])/);
      if (
        ev.keyCode === BACKSPACE &&
        this.textarea.value[startPos - 1] === "]" &&
        startPos === endPos
      ) {
        ev.preventDefault();
        let part = this.textarea.value
          .slice(0, startPos)
          .replace(/\[[^\[\]]*?\]$/, "");
        this.textarea.value =
          part + this.textarea.value.slice(selectionEnd);
        this.$nextTick(() => {
          textareaRef.setSelectionRange(part.length, part.length);
          this.setSelectionRange(textareaRef, part.length, part.length);
        });
      }
      if (list && list2) {
        startPos = list.index;
        endPos += list2[0].length;
        // textareaRef.setSelectionRange(startPos, endPos);
        this.setSelectionRange(textareaRef, startPos, endPos);
        ev.preventDefault();
      } else if (
        ev.type !== "keydown" &&
        this.textarea.value[startPos] === "[" &&
        this.textarea.value[endPos - 1] === "]"
      ) {
        setTimeout(() => {
          // textareaRef.setSelectionRange(startPos, endPos);
          this.setSelectionRange(textareaRef, startPos, endPos);
        }, 10);
        ev.preventDefault();
      }
    },

    toPreview (type) {
      this.$bus.emit("stop_listen_BGM");
      // 画布恢复正常大小
      if (this.TOOL.option.scale !== 1) {
        this.TOOL.setOption({
          width: this.Tool_Size.width,
          height: this.Tool_Size.height - 40,
          scale: 1,
          surplusY: this.TopNav_Size.height + 40,
          surplusX: this.MaterialPane_Size.width
        });
      }
      this.$bus.emit("Modal_vue", {
        name: "preview",
        data: {
          type: "record",
          select: type
        }
      });
    },
    testPlay_ (url) {
      let player = this.$refs.recordPlayer;
      if (player.playState === "play") {
        player.pause();
        return;
      }
      // 'http://oss.xfinfr.com/3B7Z8UMY/TtsResources/ca732d17-6476-4cc8-b5b7-31e008110ce9.mp3'
      url && player.changeFile(url);
      this.$nextTick(() => {
        player.play();

        // to previwe
        // this.close(false);
        // const nameMap = {
        //   global: "all",
        //   scene: "select"
        // };
        // this.$store.commit("set_IsDoingSmartVoice", {
        //   flag: true,
        //   url: url || player.fileUrl
        // });
        // this.toPreview(nameMap[this.PreviewType]);
        const readerData = this.readerOpts.find(v => this.readerId ? v.id === this.readerId : v.value === this.reader);
        this.reader = readerData.value;
        this.$store.commit("set_Reader", this.reader);
      });
    },
    testPlay () {
      if (!this.userLevelAllowedTest) {
        // this.$modal.show("SubtitleMessageDialog", {
        //   view: "TestPlayDisabled",
        //   resultCallback: ({type}) => {
        //     if (type === 'Ok') {
        //       let link = document.createElement("a");
        //       link.target = "_blank";
        //       link.href = "/workplace/pvip";
        //       link.click();
        //     }
        //   }
        // });
        this.$message({
          type: 'error',
          message: `您操作太频繁了，请明日重试`
        })
        return;
      }
      if (!this.allowedTest) {
        this.$message({
          type: 'error',
          message: `请输入文字，再试听`
        })
      }
      let player = this.$refs.recordPlayer;
      if (player.playState === "play") {
        player.pause();
        return;
      }
      // if (this.textarea.cacheValue === this.textarea.value && player.fileUrl) {
      if (this.isNotMod(0)) {
        this.testPlay_();
        return;
      }
      let p = this.send({ type: 0 });
      p &&
        p.then(({ url }) => {
          this.textarea.cacheValue = this.textarea.value;
          this.testPlay_(this.$handleAssetsUrl(url));
        });
    },
    playStart ({ duration } = {}) {
      this.getDurations({
        record: duration || 0
      });
      this.testPlayState = 'play';
    },
    onLoadedMeta ({ duration } = {}) {
      this.playStart({ duration });
    },
    playStop () {
      this.testPlayState = '';
    },

    decodeText (inputText) {
      let text = inputText || this.textarea.value;
      let myText = text.replace(/\u79d2+(?=\])/g, "秒");
      myText = myText.replace(/\t|\s+/g, " ");
      let calcText = myText;
      let durs = [];
      let points = [];

      myText.replace(/\[[0-9\.\[\]]*\u79d2\]/g, (match, ...args) => {
        //        console.log(match, args)
        let parts = myText.split(match);
        myText = parts.join("");
        parts = calcText.split(match);
        calcText = parts.join("\t");
        // return parts.join('')
        durs.push(match.match(/[0-9\.]+/g));
      });
      //      console.log(myText, durs, calcText)
      let i = 0;
      calcText.replace(/\t/g, (...args) => {
        let numDur = durs[i].reduce((memo, v) => {
          return memo + (v - 0);
        }, 0);
        points.push({
          index: args[args.length - 2] - i,
          duration: (numDur <= 20 ? numDur : 20) * 1000
        });
        i++;
      });

      return {
        points,
        text: myText
      };
    },
    getRecordParams ({ kdxf } = {}) {
      this.readerObj = this.readerOpts.find(v => this.readerId ? v.id === this.readerId : v.sourceId === this.reader);
      let decoded = this.decodeText();
      let obj = {
        type: 0,
        text: decoded.text,
        speaker: this.reader,
        speakerId: this.readerId,
        speed: this.speeds[this.readerObj.provider] + "",
        provider: this.readerObj.provider,
        pause_points: decoded.points
      };

      if (kdxf) {
        obj = {
          text: decoded.text,
          vol: 10,
          vcn: this.reader,
          speed: this.speed,
          auf: 2,
          aue: 1,
          pause_points: decoded.points
        };
      }
      return obj;
    },

    isNotMod (type) {
      let old = this.listenedParams || {};
      old = { ...old };
      old.speed = +old.speed;
      let newParams = { ...this.getRecordParams() };
      if (type != null) newParams.type = type;
      newParams.speed = +newParams.speed;
      // let ret = JSON.stringify(old) === JSON.stringify(newParams)
      let ret = this.recordParamsEqual(old, newParams);
      return ret;
    },

    recordParamsEqual (x, y) {
      let keys = ['pause_points', 'speaker', 'speed', 'text', 'type'];
      keys.every(v => {
        let xv = x[v];
        let yv = y[v];
        if (v === 'pause_points') {
          return JSON.stringify(xv) === JSON.stringify(yv);
        }
        if (v === 'speed') {
          return +xv === + yv;
        }
        return xv === yv;
      })
    },

    checkVip () {
      let popupShowed;
      let { kdxfRemain, kdxfTimes } = this.UserMsg;
      if (!kdxfRemain && this.UserLevelType < 1) {
        this.$modal.show("vipDialog", {
          msg: "升级个人VIP，解锁240次AI配音权益。",
          target: "vipsolo",
          type: "solo",
          bottomLink: '/workplace/vip',
          bottomLinkText: 'AI配音无限次使用,点击了解高级会员。',
          trackingSource: 'AIVoice',
        });
        popupShowed = true;
      } else if (!kdxfRemain && this.UserLevelType === 1) {
        let temp = this.isPersonVip
          ? "您的视频无水印次数已用完，请购买资源包叠加权益或者开通企业会员无限使用。"
          : "开通企业会员可解锁AI智能配音功能。";
        // this.$bus.emit("FeaturesPop_vue", {
        //   name: "vipEquity",
        //   msg: temp,
        //   type: 2,
        //   btnMsg: "开通企业会员",
        //   btnMsgLink: "/workplace/vip",
        //   baiduAction: "upgradeAidubVip"
        // });
        this.$modal.show("vipDialog", {
          msg: temp,
          target: "vip",
          type: "vip",
          trackingSource: 'AIVoice',
        });
        popupShowed = true;
      }
      return popupShowed;
    },

    // 发送合成（试听）请求
    send ({
      isSaveStore = true,
      type = 1 // 0 试听 | 1 合成
    } = {}) {
      // let popupShowed = type === 1 ? this.checkVip() : false;
      // if (popupShowed) {
      //   return;
      // }
      const TEST = 0;
      const GENERATE = 1;
      let myResolve;
      let myReject;
      if (!this.allowedTest) {
        return;
      }

      this.isGenerating = true;
      this.isGeneratingSuccess = false;
      let recordParams = this.getRecordParams();
      const readerObj = this.readerObj || {};
      if (readerObj.category === '3' && /[\u4e00-\u9fa5]/.test(recordParams.text)) {
        this.progressTip.isShow = false;
        this.isGenerating = false;
        this.$message({
          message: '该音库不支持中文，请输入英文。',
          type: "error"
        });
        return
      }
      let queryParams = {
        // data: this.getRecordParams(),
        // text: recordParams.text,
        ...recordParams,
        type,
        speaker: this.reader,
        speakerId: this.readerId,
        speed: this.speeds[this.readerObj.provider] + "",
        provider: this.readerObj.provider,
        gender: this.readerObj.sex,
        pitch: this.readerObj.pitch,
        verboseText: this.$refs.textareaRef.value,
        payType: this.readerObj.aiType
      };

      if (this.isNotMod(type)) {
        queryParams.isNotModified = true;
        queryParams.trialsUrl = this.geneUrl;
      } else {
        queryParams.isNotModified = false;
      }
      // if (type == 1) {
      // }
      this.$http
        .post("/api/user/audioAI", queryParams)
        .then(async (res) => {
          let { data, code, msg } = res.data;
          if (typeof data === "string") {
            let str = data;
            data = {
              body: {
                url: str,
                filename: str
              }
            };
          }
          if (data.filename) {
            let str = data.filename;
            data = {
              body: {
                url: str,
                filename: str
              }
            };
          }

          if (code !== 200 || !data.body.url) {
            this.$message({
              message: msg || data.message,
              type: "error"
            });
            this.isGenerating = false;
            return;
          }

          await this.fetchTestVoiceCount();

          data.body.url = this.$handleAssetsUrl(data.body.url);

          // this.getRemainChars();
          // if (code === 412) {
          //   // 用完了合成字数

          //   return;
          // }

          this.geneUrl = typeof data === "string" ? data : data.body.url;
          this.geneFileName =
            typeof data === "string" ? data : data.body.filename;
          if (type === GENERATE) {
            this.step.name = "name";
          }
          this.isGenerating = false;
          this.isGeneratingSuccess = true;

          // if (type === 0) {
          //   this.listenedParams = queryParams;
          // }
          this.listenedParams = queryParams;

          let respUrl = typeof data === "string" ? data : data.body.url;
          let fileDur = await this.getDurationAsync(this.$handleAssetsUrl(respUrl)) || 0;
          fileDur = fileDur.toFixed(1) - 0;
          this.audioDur = fileDur;
          if (isSaveStore && type === 1 && !this.voiceData) {
            let voiceList = this.$store.getters['smartVoice/list'];
            voiceList = [...voiceList, {
              queryParams,
              url: data.body.url,
              filename: this.$unhandleAssetsUrl(data.body.filename),
              textarea: this.$refs.textareaRef.value,
              duration: fileDur
            }];
            this.$store.commit('smartVoice/setList', voiceList);
            this.$emit('addDone');
          }
          if (isSaveStore && type === 1 && this.voiceData) {
            let voiceList = this.$store.getters['smartVoice/list'];
            voiceList.some((v, i) => {
              let matched = v.filename === this.voiceData.filename;
              if (matched) {
                voiceList[i] = {
                  ...v,
                  queryParams,
                  url: data.body.url,
                  filename: this.$unhandleAssetsUrl(data.body.filename),
                  textarea: this.$refs.textareaRef.value,
                  duration: fileDur
                }
                this.$store.commit('smartVoice/setList', [...voiceList]);
              }
              return matched;
            });
            this.$emit('editDone');
          }

          myResolve({
            url: respUrl
          });

          // this.getDurationAsync(this.$handleAssetsUrl(respUrl))
          //   .then((d) => {
          //     this.audioDur = d.toFixed(1);
          //   })

          // let voiceUsing = Promise.resolve({});

          // 减少权益
          // if (type === 1) {
          //   voiceUsing = this.$http.post("/api/user/audioAI/use", {
          //     kdxf: 1
          //   });
          // }

          // voiceUsing.then(({ resData }) => {
          //   this.$bus.emit("upDataUserMsg_vue");
          //   this.$bus.once("upDataUserMsg_vue_done", function hdr () {
          //     myResolve({
          //       url: typeof data === "string" ? data : data.body.url
          //     });
          //   });

          //   return resData;
          // });
        })
        .catch(err => {
          this.$message({
            message: "系统开小差了",
            type: "error"
          });
          this.isGenerating = false;
          this.err(err);
          myReject(err);
        });

      return new Promise((resolve, reject) => {
        myResolve = resolve;
        myReject = reject;
      });
    },
    err (err) {
      console.warn(err);
    },

    async getDurationAsync (url) {
      let myResolve;
      let el = new Audio();
      el.src = url;
      el.addEventListener('loadedmetadata', function h() {
        const d = el.duration || 0;
        el.removeEventListener('loadedmetadata', h);
        el.remove();
        el.srcObject = null;
        myResolve(d);
      });
      return new Promise((resolve, reject) => {
        myResolve = resolve;
      })
    },

    async createUserRecord () {
      if (this.isLock) {
        return;
      }
      this.isLock = true;
      let contentComp = this.$refs.dialogRef.$children.filter(
        child => child.$options.name === "nameContent"
      )[0];
      let pass = contentComp.input.validate();
      let untitle;
      if (!pass) {
        this.isLock = false;
        return;
      }

      let dur = await this.$util.getMediaDuration(
        this.$handleAssetsUrl(this.geneFileName)
      );
      if (!contentComp.input.value) {
        try {
          untitle = await this.getUntitle();
        } catch (err) {
          this.isLock = false;
        }
      }

      this.$http
        .post("/api/user/music", {
          url: this.geneFileName,
          title: contentComp.input.value || untitle,
          duration: dur,
          musicType: 1
        })
        .then(({ data: resData }) => {
          let { data, code, msg } = resData;
          if (code !== 200) {
            this.$message({
              message: msg,
              type: "error"
            });
            this.step.name = "generate";
            this.close(true);
            return;
          }
          this.step.name = "generate";
          this.close(true);
          this.textarea.value = "";

          // this.$bus.emit('generateVoice.updatedName');

          // 通知右侧栏
          this.$bus.emit("collectPersonal_vue", { data: "collectMusicType" });

          let rec = {
            // endTime: duration * 1000,
            fileType: data.fileType,
            id: data.id,
            resourceId: data.id,
            startTime: 0,
            title: data.title,
            url: this.$handleAssetsUrl(data.url)
          };

          // this.$bus.emit('FeaturesPop_vue', {
          //   name: 'volume_adjust',
          //   posx: 0,
          //   posy: 0,
          //   type: 1,
          // });

          // scene or global
          // if (contentComp.addedToPlace.place === 'global') {
          if (this.PreviewType === "global") {
            this.$bus.emit("addAudioToGlobal", rec);
          } else {
            this.$bus.emit("addAudioToScene", rec);
          }

          this.isLock = false;
        })
        .catch(err => {
          this.isLock = false;
        });
    },

    getUntitle () {
      let _y, _n;
      let sOfPage = 24;
      let pIndex = 1;
      let pad = n => {
        if (n < 10) {
          n = "0" + n;
        } else {
          n = "" + n;
        }
        return n;
      };

      let p = async prevResolve => {
        let yy = prevResolve;
        this.$http
          .get("/api/user/music", {
            params: {
              pIndex: pIndex,
              fPage: sOfPage,
              sOfPage: sOfPage,
              musicType: 1
            }
          })
          .then(res => {
            let { code, data, total } = res.data;
            let arr = data.filter(item => {
              return item.title && /未命名\d+$/.test(item.title);
            });

            if (pIndex * sOfPage > total && !arr[0]) {
              yy({
                title: "未命名00"
              });
              return;
            }
            // if (total > sOfPage) {
            if (!arr[0]) {
              // sOfPage *= 2;
              pIndex += 1;
              p(yy);
            } else {
              yy(arr[0]);
            }
          });

        return (
          !yy &&
          new Promise((y, n) => {
            yy = y;
          })
        );
      };

      p().then(item => {
        // let {code, data} = res.data;
        // let arr = data.filter((item) => {
        //   return item.title && /未命名\d+/.test(item.title);
        // });
        let num = item.title.replace(/^.*?(\d+)/, "$1") - 0;
        let title = `未命名${pad(num + 1)}`;
        _y(title);
      });

      return new Promise((resolve, reject) => {
        _y = resolve;
      });
    },

    async onSelectText (ev) {
      let el = ev.currentTarget;
      let { selectionStart, selectionEnd, value } = this.getSelection(el);
      let s = selectionStart;
      let e = selectionEnd;
      let val = el.value;
      if (e - s === 1 && /[\u4e00-\u9fa5]/.test(val[s])) {
        // 获取读音
        let resp = await this.$http.get(`/api/user/audioAI/source/getPinyin?word=` + val[s]);
      } else {
        // this.$message({
        //   message: '请选中单个汉字之后使用多音字功能。',
        //   type: "error"
        // });
      }
    },
    setNumberSpeaking (item) {
      this.settingNumberSpeaking = true;
      let el = this.$refs.textareaRef;
      let { selectionStart, selectionEnd, value } = this.getSelection(el);
      let selection = value.slice(selectionStart, selectionEnd) || '';
      let isNumber = /^[0-9]+$/.test(selection);
      if (selectionStart < selectionEnd && isNumber) {
        let parts = [];
        parts[0] = value.slice(0, selectionStart) || '';
        parts[1] = value.slice(selectionStart, selectionEnd) || '';
        parts[2] = value.slice(selectionEnd) || '';
        let tag = '[n' + item.value + ']'
        parts[1] = tag + parts[1] + tag;
        if (parts[0].slice(-4) === parts[2].slice(0, 4)) {
          parts[0] = parts[0].slice(0, -4);
          parts[2] = parts[2].slice(4);
        }
        this.textarea.value = parts.join('');
      } else {
        this.$message({
          message: '请选中数字之后使用数字读法功能。',
          type: "error"
        });
      }
    },
    setCharPolyphone (item) {
      let pinyinRE = /^\[\=[a-z]{1,6}[1-9]?\]/;
      let el = this.$refs.textareaRef;
      let { selectionStart, selectionEnd, value } = this.getSelection(el);
      let selection = value.slice(selectionStart, selectionEnd) || '';
      let parts = [];
      parts[0] = value.slice(0, selectionEnd);
      parts[1] = value.slice(selectionEnd);
      let pinyin = '[=' + item.value + ']';
      parts[0] += pinyin;
      parts[1] = parts[1].replace(pinyinRE, '');
      this.textarea.value = parts.join('');
    },
    async getPolyphone () {
      let el = this.$refs.textareaRef;
      let { selectionStart, selectionEnd, value } = this.getSelection(el);
      let selection = value.slice(selectionStart, selectionEnd) || '';
      if (selection.length === 1 && /[\u4e00-\u9fa5]/.test(selection)) {
        // 获取读音
        let resp = await this.$http.get(`/api/user/audioAI/source/getPinyin?word=` + selection);
        let polyphone = [];
        try {
          polyphone = resp.data.data.spell;
          polyphone = polyphone.split(',');
        } catch (e) {
          polyphone = [];
          this.$message({
            message: '您选中的汉字不是多音字哦',
            type: "error"
          });
        }
        this.polyphoneList = polyphone.map(item => {
          return {
            label: item,
            value: item
          }
        });
      } else {
        this.polyphoneList = [];
        this.$message({
          message: '请选中单个汉字之后使用多音字功能。',
          type: "error"
        });
      }
    },
    onPolyphoneMenuToggle (flag) {
      if (flag) {
        this.$refs.textareaRef.focus();
        this.getPolyphone();
      } else {
        this.polyphoneList = [];
      }
    },
    onNumberMenuToggle (flag) {
      if (flag) {
        this.$refs.textareaRef.focus();
      }
    },
    getReaderNames (provider = 2) {
      return this.readerOpts.filter(v => v.provider === provider).map(v => v.sourceName);
    },
    shorten (inputText) {
      let text = inputText || this.textarea.value;
      if (!text) {
        return;
      }
      // text.replace(/(\[[0-9\.\[\]]*\u79d2\])+/g, (...args) => {
      // })
      let obj = this.decodeText(text);
      let points = obj.points;
      if (points && !points.length) {
        return;
      }
      let max = 20;
      let reader = (this.readerOpts.filter(v => this.readerId ? v.id === this.readerId : v.value === this.reader) || [])[0];
      if (reader.provider === 2) {
        max = 3;
      }
      let pauses = [];
      points.forEach(v => {
        if (pauses.indexOf(v.index) < 0) {
          pauses.push(v.index);
        }
      });
      let myPoints = [];
      pauses.forEach(v => {
        let fArr = points.filter(p => p.index === v);
        let sum = getSum(fArr, 'duration');
        while (sum > max * 1000) {
          fArr.pop();
          sum = getSum(fArr, 'duration');
        }
        myPoints = [...myPoints, ...fArr];
      });
      let gap = 0;
      let myText = obj.text;
      myPoints.forEach(v => {
        gap = myText.length - obj.text.length;
        let parts = [];
        parts[0] = myText.slice(0, v.index + gap);
        parts[1] = `[${(v.duration / 1000).toFixed(1)}秒]`
        parts[2] = myText.slice(v.index + gap);
        myText = parts.join('');
      });

      function getSum (arr, key) {
        let sum = 0;
        arr.forEach(v => {
          sum += v[key];
        });
        return sum;
      }

      return myText;
    },
    onPaste (ev) {
      let pasting = ev.clipboardData.getData('Text');
      // ev.currentTarget.textContent = ev.currentTarget.textContent.replace(/<[\/\s]*(?:(?!div|br)[^>]*)>/g, '');
      // ev.preventDefault();
      // let text = ev.clipboardData.getData('text/plain');
      // document.execCommand('insertText', false, text);
      // if (ev.currentTarget.textContent.length > this.textarea.maxlength) {
      //   ev.currentTarget.textContent = ev.currentTarget.textContent.slice(0, this.textarea.maxlength);
      //   ev.preventDefault();
      // }
      if (/^\[[0-9\.\[\]]*\u79d2\]$/.test(pasting)) {
        ev.preventDefault();
      }
    },
    onChange2 () {
      let textarea = this.$refs.textareaRef;
      let ele = document.createElement('div');
      ele.style.position = 'fixed';
      ele.style.opacity = '0';
      ele.style.width = $(textarea).css('width');
      ele.style.lineHeight = $(textarea).css('lineHeight');
      ele.style.fontSize = '12px';
      // ele.style.wordBreak = 'break-all';
      ele.style['word-wrap'] = 'break-word';
      ele.innerText = this.textarea.value.slice(0, 350);
      $(ele).appendTo('body');
      let sh = ele.scrollHeight;
      $(ele).remove();
      textarea.style.height = 'auto';
      textarea.scrollHeight;
      textarea.style.height = ''; // 让 textarea 的高度恢复默认
      textarea.style.height = Math.min(sh, textarea.scrollHeight) + 'px';
    },
    onChange () {
      if (this.textarea.value.length > this.textarea.maxlength) {
        this.onChange2();
        return;
      }
      let textarea = this.$refs.textareaRef;
      textarea.style.height = ''; // 让 textarea 的高度恢复默认
      textarea.style.height = textarea.scrollHeight + 'px';
      this.textarea.value
    },
    onInput (text) {
      this.textarea.value = text;
    },
    onBodyMouseUp (e) {
      if (e.target.classList.contains('el-slider__button')) {
        return;
      }
      this.sliderTipVisible = false;
    },
    showProviderPauseMsg ({ max, names } = {}) {
      this.$modal.show('MessageDialog', {
        contentHtml: true,
        content:
          `因角色功能差异，下列角色不支持连续停顿超过${max}.0秒：${names}。<br/>如有较长停顿需求,请更换其他音色尝试~`,
        btns: [{ type: "custom", content: "知道了" }],
        resultHandler: type => {
        }
      });
    },
    getSelection (el) {
      if (el.tagName === 'TEXTAREA') {
        return el;
      }
      let s = document.getSelection();
      return {
        selectionStart: s.baseOffset,
        selectionEnd: s.extentOffset,
        value: el.textContent
      }
    },
    setSelectionRange (el, start, end) {
      if (el.tagName === 'TEXTAREA') {
        el.setSelectionRange(start, end);
        return;
      }
      var node = el;
      let min = 0;
      let max = el.textContent.length;
      start = Math.max(min, Math.min(max, start))
      end = Math.max(min, Math.min(max, end))
      var range = document.createRange();
      range.setStart(node, start);
      range.setEnd(node, end);
    },
    cancel () {
      this.$emit('cancel')
    },
    async fetchTestVoiceCount () {
      if (this.UserLevelInfo.levelName === 'basic') {
        const {data} = await this.$http.get('/api/user/audioAI/getTimes');
        const {times, useTimes} = data.data;
        const remain = Math.max(0, times - useTimes);
        this.testingVoiceMsg = `(${remain}/${times})`;
        if (remain > 100) {
          this.testingVoiceMsg = '';
        }
        this.testingVoiceInfo = {total: times, remain};
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-free {
  width: 30px;
  height: 17px;
  background-image: url(../../../../assets/smartVoice/free.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: -2px;
}
.voice-editor {
  display: flex;
  color: #474261;
}
.reader {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 44px;
  margin-right: 20px;
  & .name {
    font-size: 12px;
    color: #474261;
    white-space: nowrap;
  }
}
.figure-wrapper {
  position: relative;
  .badge {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 7px;
    color: #fff;
    font-size: 10px;
    width: 50px;
    height: 14px;
    // background-repeat: no-repeat;
    // background-size: 100% 100%;
    // background-image: url(data:image/svg+xml;base64,PHN2ZyBpZD0i5Zu+5bGCXzEiIGRhdGEtbmFtZT0i5Zu+5bGCIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCA1MCAxNiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOnVybCgj5pyq5ZG95ZCN55qE5riQ5Y+YKTt9LmNscy0ye2lzb2xhdGlvbjppc29sYXRlO2ZvbnQtc2l6ZToxMHB4O2ZpbGw6I2ZmZjtmb250LWZhbWlseTpNaWNyb3NvZnRZYUhlaSwgTWljcm9zb2Z0IFlhSGVpO308L3N0eWxlPjxsaW5lYXJHcmFkaWVudCBpZD0i5pyq5ZG95ZCN55qE5riQ5Y+YIiB4MT0iMzMuMjUiIHkxPSItNi4yOSIgeDI9IjE2Ljc1IiB5Mj0iMjIuMjkiIGdyYWRpZW50VHJhbnNmb3JtPSJtYXRyaXgoMSwgMCwgMCwgLTEsIDAsIDE2KSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPjxzdG9wIG9mZnNldD0iMCIgc3RvcC1jb2xvcj0iIzJmNThmZSIvPjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iIzQ5YTZmYyIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjx0aXRsZT41MHgxNiDkvIHkuJpWSVDop5LmoIc8L3RpdGxlPjxwYXRoIGNsYXNzPSJjbHMtMSIgZD0iTTgsMEg0MmE4LDgsMCwwLDEsOCw4aDBhOCw4LDAsMCwxLTgsOEg4QTgsOCwwLDAsMSwwLDhIMEE4LDgsMCwwLDEsOCwwWiIvPjx0ZXh0IGNsYXNzPSJjbHMtMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNy4wOSAxMS41MykiPuS8geS4mlZJUDwvdGV4dD48L3N2Zz4=);

    content: url(../../../../../static/svg/payTypeSubscript/companyVip.svg);
    &.person {
      width: 36px;
      height: 14px;
      content: url(../../../../../static/svg/payTypeSubscript/commonVip.svg);
      background-image: none;
    }
    &.enterpriseS {
      width: 50px;
      height: 14px;
      content: url(../../../../../static/svg/payTypeSubscript/enterpriseSVIP.svg);
      background-image: none;
    }
    &.pro {
      width: 30px;
      height: 18px;
      content: url(../../../../assets/pro.png);
      background-image: none;
    }
    &.proPlus {
      width: 32px;
      height: 18px;
      content: url(../../../../assets/proPlus.png);
      background-image: none;
    }
  }
}
.figure {
  width: 44px;
  height: 44px;
  background: #d8dee9;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 4px;
  & > img {
    width: 100%;
    height: 100%;
  }
}
.voice-editor > .content > .text {
  width: 451px;
  min-height: 40px;
  background: #ffffff;
  border: 1px solid #d8dee9;
  padding: 12px 16px;
}
.textarea {
  overflow: hidden;
  resize: none;
  height: 16px;
  line-height: 16px;
  font-size: 12px;
  width: 100%;
  border: none;
}
.voice-editor > .content {
  box-shadow: 0px 2px 6px rgba(136, 136, 136, 0.16);
}
.control {
  margin-top: 3px;
  width: 451px;
  height: 130px;
  background: #ffffff;
  box-shadow: 0px 2px 6px rgba(136, 136, 136, 0.16);
  & > .row {
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;
    padding-top: 25px;
    padding-bottom: 22px;
    padding-left: 16px;
  }
  & .row-item {
    display: flex;
    align-items: center;
    &__content {
      display: flex;
    }
    &__content .btn-small {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      background: #f6f6fc;
      border: 1px solid #d8dee9;
      border-radius: 4px;
      font-size: 12px;
      color: #737596;
      margin-left: 10px;
      cursor: pointer;
      &:last-child {
        // margin-left: 0;
      }
    }
  }
  & .menu-container {
    margin-left: 30px;
  }
  & .speed-range {
    display: flex;
    align-items: center;
    padding-left: 16px;
    & > .content {
      margin-left: 12px;
      height: 32px;
      display: flex;
      align-items: flex-end;
    }
    & .range-wrapper {
      height: 16px;
    }
  }
}
.submit {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 451px;
  height: 50px;
  background: #f6f6fc;
  border-radius: 0px 0px 4px 4px;
  & .test-play {
    display: flex;
    align-items: center;
    height: 30px;
    // cursor: pointer;
    margin-right: 10px;
    &>svg {
      cursor: pointer;
    }
    &>svg.is-disabled {
      cursor: not-allowed;
    }
    & > .text {
      margin-left: 10px;
      margin-right: 10px;
    }
    &>svg:hover {
      & svg {
        opacity: 0.8;
      }
    }
  }
  & .confirm {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 26px;
    background: #5778fb;
    opacity: 1;
    border-radius: 4px;
    font-size: 14px;
    color: #ffffff;
    margin-left: 8px;
    margin-right: 16px;
    cursor: pointer;
    text-align: center;
    font-size: 12px;

    &:hover {
      background-color: #7d95f5;
    }

    &.is-disabled {
      opacity: 0.2;
      cursor: not-allowed;
    }
  }
}
.is-disabled {
  opacity: 0.2;
  cursor: not-allowed;
}
.cancel {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 26px;
  background: #ffffff;
  border: 1px solid #d9ddea;
  border-radius: 4px;
  color: #737596;
  cursor: pointer;
  font-size: 12px;
}

.testing-remain {
  position: relative;
  display: flex;
  align-items: center;
  &>span {
    margin-right: 10px;
  }
  &-tip {
    position: absolute;
    top: -40px;
    left: -28px;
    display: none;
    align-items: center;
    justify-content: center;
    min-width: 223px;
    height: 31px;
    background: rgba(#000000, .5);
    border-radius: 4px;
    color: white;
    font-size: 12px;
  }
  &:hover > .testing-remain-tip {
    display: flex;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/subtitle/dialogs/smartVoice/voiceEditor.vue